var version = "4.9.0";
export { version as default };
//# sourceMappingURL=Version.js.map
